module.exports = __webpack_public_path__ + "img/beranda.464fa57.png";